import axios from 'axios';
import StatusCode from './statusCode';
import config from '../util/config';
import { refresh } from './auth.service';
import {
    getIsRefreshing,
    setIsRefreshing,
    enqueueRequestResolver,
    resolveQueuedRequests,
    rejectQueuedRequests
} from './tokenRefreshManager';

export const engineApi = (dontUseAuthorizationHeader) => {
    const baseConfig = {
        baseURL: config.ENGINE_ENDPOINT_URL
    };
    const createInstance = (baseConfig) => {
        const instance = axios.create(baseConfig);
        instance.defaults.headers.common['Content-Type'] = 'application/json';
        instance.interceptors.request.use(
            async (config) => {
                if (dontUseAuthorizationHeader) return config;
                const token = await localStorage.getItem('accessToken');
                if (token && config.url !== '/login') {
                    config.headers = {
                        ...(config.headers || {}),
                        Authorization: `Bearer ${token}`
                    };
                    config.headers['Content-Type'] = 'application/json';
                }
                return config;
            },
            (error) => {
                Promise.reject(error);
            }
        );
        return instance;
    };

    const instance = createInstance(baseConfig);

    instance.interceptors.response.use(
        async (response) =>
            // eslint-disable-next-line implicit-arrow-linebreak
            response,
        async (error) => {
            if (error.config.url !== '/refresh') {
                const originalRequest = error.config;
                switch (error.response.status) {
                    case StatusCode.UNAUTHORIZED:
                        if (!getIsRefreshing()) {
                            try {
                                setIsRefreshing(true);
                                const {
                                    data: { accessToken, refreshToken }
                                } = await refresh({
                                    accessToken: localStorage.getItem('accessToken'),
                                    refreshToken: localStorage.getItem('refreshToken')
                                });
                                localStorage.setItem('accessToken', accessToken);
                                localStorage.setItem('refreshToken', refreshToken);
                                resolveQueuedRequests();
                                return engineApi()(originalRequest);
                            } catch (err) {
                                rejectQueuedRequests(err);
                                localStorage.removeItem('accessToken');
                                localStorage.removeItem('refreshToken');
                                delete instance.defaults.headers.common.Authorization;
                                window.location.href = '/';
                            } finally {
                                setIsRefreshing(false);
                            }
                        }
                        return new Promise((resolve) => {
                            enqueueRequestResolver(() => {
                                resolve(engineApi()(originalRequest));
                            });
                        });
                        break;
                    default:
                        throw error.response;
                }
            } else {
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                delete instance.defaults.headers.common.Authorization;
                window.location.href = '/';
            }
        }
    );

    return instance;
};

export default engineApi;
